import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  amount: {
    textAlign: 'right',
    display: 'block',
  },
  amountTotal: {
    fontWeight: 'bold',
    color: theme.palette.themePrimary,
  },
  link: {
    width: '100%',
    fontSize: FontSizes.medium,
    color: theme.palette.black,
    ':focus': {
      color: theme.palette.black,
    },
  },
  overageAmount: {
    color: theme.palette.red,
  },
  notesCountContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    minWidth: 20,
    height: 20,
    backgroundColor: theme.palette.orangeLighter,
  },
  callout: {
    width: 400,
  },
  idCallStylesBox: {
    padding: 5,
    borderRadius: 5,
    border: `solid 1px ${theme.palette.themePrimary}`,
  },
  tripSectionNotesContainer: {
    padding: 5,
    border: `1px solid ${theme.palette.neutralDark}55`,
    borderRadius: 5,
  },
}));
